module.exports = __webpack_public_path__ + "static/media/background.fb02a7c0.png";